import {Injectable} from '@angular/core';
import {AngularFirestore, DocumentChangeAction} from '@angular/fire/compat/firestore';
import {firstValueFrom, from, map, Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {last, switchMap} from 'rxjs/operators';
import {lastValueFrom} from 'rxjs';
import {AngularFireFunctions} from '@angular/fire/compat/functions';


@Injectable({
  providedIn: 'root'
})
export class SitePublicService {

  public objectImage: any = null;
  public storedImage: any;

  constructor (
    public db: AngularFirestore,
    public authService: AuthService,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
  ) { }

  // STORGE

  deleteFileInStorage (src: any) {
    const fsRef: any = this.fs.storage.refFromURL(src);
    fsRef.delete();
  }

  //PAGEs

  getPage (depto_name: string, page_name: string): Observable<any | undefined> {

    // 1. Encontrar o ID do Departamento (Depto) usando o nome
    const deptoQuery = this.db.collection('pub_deptos').ref
      .where('short', '==', depto_name)
      .limit(1)
      .get();

    // Converte a Promessa (Promise) do .get() em um Observable usando 'from'
    return from(deptoQuery).pipe(
      // Mapeia o resultado da primeira consulta (Departamentos)
      // AQUI: Deixe o TypeScript INFERIR o tipo do QuerySnapshot (remova a tipagem explícita!)
      switchMap((deptoSnapshot) => {
        if (deptoSnapshot.empty) {
          console.warn(`Departamento com nome "${ depto_name }" não encontrado.`);
          return [ undefined ];
        }

        const deptoDoc = deptoSnapshot.docs[ 0 ];
        const deptoId = deptoDoc.id;

        // 2. Encontrar a Página (Page) usando o nome dentro da subcoleção
        const pageQuery = this.db.collection('pub_deptos').doc(deptoId)
          .collection('pages').ref
          .where('name', '==', page_name)
          .limit(1)
          .get();

        // Retorna a Promessa (Promise) da segunda consulta
        return from(pageQuery).pipe(
          // Mapeia o resultado da segunda consulta (Páginas)
          // AQUI: Deixe o TypeScript INFERIR o tipo do QuerySnapshot!
          map((pageSnapshot) => {
            if (pageSnapshot.empty) {
              console.warn(`Página com nome "${ page_name }" não encontrada no depto "${ depto_name }".`);
              return undefined;
            }

            const pageDoc = pageSnapshot.docs[ 0 ];

            return {
              depto_id: deptoId,
              page_id: pageDoc.id,
              ...pageDoc.data()
            };
          })
        );
      })
    );
  }

  /**
 * Abre uma nova aba e exibe o conteúdo HTML fornecido.
 * @param pageHtml A string contendo o HTML completo (incluindo <style> embutidos).
 */
  public displayHtmlInNewTab (pageHtml: any): void {
    // 1. Abrir uma nova janela ou aba do navegador
    // O primeiro parâmetro ('') é a URL (vazio para um documento em branco)
    // O segundo parâmetro ('_blank') garante que uma nova aba seja aberta
    const newWindow = window.open('', '_blank');

    // Verifica se a janela foi aberta com sucesso (pode falhar se o pop-up for bloqueado)
    if (newWindow) {
      // 2. Escrever o HTML completo na nova janela
      newWindow.document.open(pageHtml);

      // 3. Fechar o stream do documento para que o navegador processe o HTML
      // e renderize a página (muito importante!)
      newWindow.document.close();

      // Opcional: focar na nova janela
      newWindow.focus();
    } else {
      // Lidar com o bloqueio de pop-up
      alert('O navegador bloqueou a abertura da nova aba. Por favor, permita pop-ups.');
    }
  }


  public displayHtml (pageHtml: any): void {

    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.document.write(pageHtml);
      newWindow.document.close();
      newWindow.focus();
    } else {
      alert('O navegador bloqueou a abertura da nova aba. Por favor, permita pop-ups.');
    }
  }

  // DIRETORIA  ///////////////////////

  selectBienniums (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_directors', ref => ref
      .orderBy('period', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  selectBienniumDirectors (id: string): Observable<any[]> {
    return this.db.collection<any>('pub_directors/' + id + "/directors/", ref =>
      ref.orderBy('position', 'asc')
    ).snapshotChanges().pipe(
      map(snapshotActions => snapshotActions.map(action => {
        const docData = action.payload.doc.data();
        return {
          id: action.payload.doc.id,
          ...docData
        };
      }))
    );
  }

  insertBiennium (entity: any) {
    return this.db.collection('pub_directors').add(Object.assign({}, entity));
  }

  updateBiennium (entity: any) {
    return this.db.collection('pub_directors').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteBiennium (entity_id: any) {
    return this.db.collection('pub_directors').doc(entity_id).delete();
  }

  async getDirectorsRoles (): Promise<any[]> {
    try {
      // 1. Constrói a query e obtém o Observable
      const memberQuery = this.db.collection<any>('pub_directors_roles', ref => ref
        .orderBy('position', 'asc')
      ).get();

      // 2. Converte o Observable em uma Promise usando firstValueFrom
      const snapshot = await firstValueFrom(memberQuery);

      // 3. Mapeia os documentos do snapshot para um array de dados
      const roles: any[] = snapshot.docs.map(doc => {
        // Usa o spread operator para incluir o ID do documento
        return {
          id: doc.id,
          name: doc.data().name,
          position: doc.data().position
        };
      });

      // console.log(`directors roles encontrados: ${ roles.length }`);
      return roles;

    } catch (error) {
      console.error("Erro ao executar a consulta no Firestore:", error);
      // É melhor retornar um array vazio em caso de falha do que lançar o erro para quem chama.
      return [];
    }
  }

  insertBienniumDirector (id: string, entity: any) {
    return this.db.collection('pub_directors')
      .doc(id)
      .collection('directors')
      .add(Object.assign({}, entity));
  }

  deleteBienniumDirector (period_id: string, director_id: string) {
    return this.db.collection('pub_directors')
      .doc(period_id)
      .collection('directors')
      .doc(director_id)
      .delete();
  }

  // ESTATUTO ////////////////////////

  loadStatute (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_statute', ref => ref
      .orderBy('position', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            ...docData
          };
        });
        return array;
      })
      // Não tem try/catch aqui, o tratamento de erro deve ser feito com o pipe 'catchError'
      // ou na subscrição no componente.
    );
  }

  insertStatute (entity: any) {
    return this.db.collection('pub_statute')
      .add(Object.assign({}, entity));
  }

  updateStatute (id: string, entity: any) {
    return this.db.collection('pub_statute')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteStatute (statute_id: string) {
    return this.db.collection('pub_statute')
      .doc(statute_id)
      .delete();
  }

  // EXPOSITOTES ////////////////////////

  loadExhibitors (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_exhibitors', ref => ref
      .orderBy('position', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
      // Não tem try/catch aqui, o tratamento de erro deve ser feito com o pipe 'catchError'
      // ou na subscrição no componente.
    );
  }

  insertExhibitors (entity: any) {
    return this.db.collection('pub_exhibitors')
      .add(Object.assign({}, entity));
  }

  updateExhibitors (id: string, entity: any) {
    return this.db.collection('pub_exhibitors')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteExhibitors (exhibitor_id: string) {
    return this.db.collection('pub_exhibitors')
      .doc(exhibitor_id)
      .delete();
  }



  // PDFs ////////////////////////

  loadPDFs (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_pdfs', ref => ref
      .orderBy('key', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            ...docData
          };
        });
        return array;
      })
      // Não tem try/catch aqui, o tratamento de erro deve ser feito com o pipe 'catchError'
      // ou na subscrição no componente.
    );
  }

  loadbExhibitorsPDFs (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_exhibitors_pdfs', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
      // Não tem try/catch aqui, o tratamento de erro deve ser feito com o pipe 'catchError'
      // ou na subscrição no componente.
    );
  }

  uploadPDF (file: File, key: string, storagePath: string): Promise<string> {
    //
    const filePath = `${ storagePath }/${ key }.pdf`;
    const fsRef: AngularFireStorageReference = this.fs.ref(filePath);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    // 1. Defina o Observable de upload e registro
    const upload$ = fsTask.snapshotChanges().pipe(
      // last() garante que o Observable só emitirá o valor quando o upload estiver completo.
      last(),

      // switchMap passa o controle para a obtenção da URL
      switchMap(() => fsRef.getDownloadURL()),

      // switchMap novamente: recebe a URL e a usa para registrar no Firestore
      switchMap((url: string) => {
        // Retorna a Promise do set(), que será convertida de volta para um Observable pelo switchMap
        return this.db.collection(storagePath).doc(key).set({pdf_name: file.name, pdf_url: url}, {merge: true})
          .then(() => url); // Se o set for bem-sucedido, resolve com a URL
      })
    );

    // 2. Converta o Observable final para uma Promise usando lastValueFrom
    // lastValueFrom espera que o Observable complete (o que acontece após o último switchMap
    // e o último then() ser executado) para resolver a Promise.
    return lastValueFrom(upload$);
  }

  uploadExhibitorsPDF (file: File, formData: any, storagePath: string): Promise<string> {
    //
    const filePath = `${ storagePath }/${ formData.key }.pdf`;
    const fsRef: AngularFireStorageReference = this.fs.ref(filePath);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    // 1. Defina o Observable de upload e registro
    const upload$ = fsTask.snapshotChanges().pipe(
      // last() garante que o Observable só emitirá o valor quando o upload estiver completo.
      last(),

      // switchMap passa o controle para a obtenção da URL
      switchMap(() => fsRef.getDownloadURL()),

      // switchMap novamente: recebe a URL e a usa para registrar no Firestore
      switchMap((url: string) => {
        // Retorna a Promise do set(), que será convertida de volta para um Observable pelo switchMap
        return this.db.collection(storagePath).doc(formData.key).set({name: formData.name, key: formData.key, pdf_name: file.name, pdf_url: url}, {merge: true})
          .then(() => url); // Se o set for bem-sucedido, resolve com a URL
      })
    );

    // 2. Converta o Observable final para uma Promise usando lastValueFrom
    // lastValueFrom espera que o Observable complete (o que acontece após o último switchMap
    // e o último then() ser executado) para resolver a Promise.
    return lastValueFrom(upload$);
  }

  async deletePDF (path: string, key: string): Promise<void> {
    // 1. Constrói a referência do Storage (deve ser o mesmo caminho usado no upload)
    const filePath = `${ path }/${ key }.pdf`;
    const fsRef: AngularFireStorageReference = this.fs.ref(filePath);

    // 2. Constrói a referência do Firestore
    const docRef = this.db.collection(path).doc(key);

    // 3. Encadeamento das operações:

    // Inicia a exclusão do registro do Firestore
    return docRef.delete()
      .then(() => {
        // Se a exclusão do Firestore for bem-sucedida, prossegue para o Storage.
        // Nota: O método delete() do Storage retorna uma Promise<void>.
        return fsRef.delete().toPromise();
      })
      .then(() => {
        // Se a exclusão do Storage for bem-sucedida, a Promise resolve.
        console.log(`Exclusão completa para a key: ${ key }`);
        return;
      })
      .catch((error) => {
        // Captura qualquer erro, seja do Firestore ou do Storage.
        console.error(`Erro ao deletar o PDF (key: ${ key }):`, error);
        // Rejeita a Promise, permitindo que o chamador trate o erro.
        throw error;
      });
  }

  getPDFByKey (key: string): Observable<any | undefined> {

    // 1. Obtém a referência do documento usando doc(key)
    return this.db.collection('pub_pdfs').doc<any>(key)

      // 2. Chama valueChanges() para obter o objeto de dados (sem metadados)
      // O valor retornado é o documento, ou undefined se não existir.
      .valueChanges({idField: 'key'}) // idField: 'key' anexa o ID do documento ao objeto
      .pipe(
        // O map é opcional, mas pode ser usado para transformar os dados
        map(doc => {
          if (doc) {
            // Garantimos que o ID está presente no objeto
            return {...doc, key: key};
          }
          return undefined;
        })
      );
  }

  // HSITORIA //////////////////////////

  getHistory (key: string): Observable<any | undefined> {
    return this.db.collection('pub_history').doc<any>(key)
      .valueChanges({idField: 'key'})
      .pipe(
        map(doc => {
          if (doc) {
            return {...doc, key: key};
          }
          return undefined;
        })
      );
  }

  setHistory (entity: any) {
    return this.db.collection('pub_history')
      .doc(entity.id)
      .set(Object.assign({}, entity));
  }

  // CONDUCT //////////////////////////

  getConduct (key: string): Observable<any | undefined> {
    return this.db.collection('pub_conduct').doc<any>(key)
      .valueChanges({idField: 'key'})
      .pipe(
        map(doc => {
          if (doc) {
            return {...doc, key: key};
          }
          return undefined;
        })
      );
  }

  setConduct (entity: any) {
    return this.db.collection('pub_conduct')
      .doc(entity.id)
      .set(Object.assign({}, entity));
  }

  // CONDUCT //////////////////////////

  getSupport (key: string): Observable<any | undefined> {
    return this.db.collection('pub_support').doc<any>(key)
      .valueChanges({idField: 'key'})
      .pipe(
        map(doc => {
          if (doc) {
            return {...doc, key: key};
          }
          return undefined;
        })
      );
  }

  setSupport (entity: any) {
    return this.db.collection('pub_support')
      .doc(entity.id)
      .set(Object.assign({}, entity));
  }

  // DEPARTAMENTOS

  loadDeptos (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_deptos', ref => ref
      .orderBy('short', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertDepto (entity: any) {
    return this.db.collection('pub_deptos').add(Object.assign({}, entity));
  }

  updateDepto (entity: any) {
    return this.db.collection('pub_deptos').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteDepto (entity_id: any) {
    return this.db.collection('pub_deptos').doc(entity_id).delete();
  }

  deleteDeptoPage (depto_id: string, page_id: string) {
    return this.db.collection('pub_deptos')
      .doc(depto_id)
      .collection('pages')
      .doc(page_id)
      .delete();
  }

  /*

  loadDeptosPages (id: string): Observable<any[]> {
    return this.db.collection<any>('pub_deptos/' + id + "/pages/", ref =>
      ref.orderBy('name', 'asc')
    ).snapshotChanges().pipe(
      map(snapshotActions => snapshotActions.map(action => {
        const docData = action.payload.doc.data();
        return {
          id: action.payload.doc.id,
          name: docData.name
        };
      }))
    );
  }

  getDeptoPage (depto_id: string, page_id: string): Observable<any | undefined> {
    return this.db.collection('pub_deptos')
      .doc<any>(depto_id)
      .collection('pages')
      .doc<any>(page_id)
      .valueChanges({idField: 'page_id'})
      .pipe(
        map(doc => {
          if (doc) {
            return {
              depto_id: depto_id,
              page_id: page_id,
              ...doc
            };
          }
          return undefined;
        })
      );
  }

  insertDeptoPage (depto_id: string, entity: any) {
    return this.db.collection('pub_deptos')
      .doc(depto_id)
      .collection('pages')
      .add(Object.assign({}, entity));
  }

  updateDeptoPage (depto_id: string, page_id: string, entity: any) {
    return this.db.collection('pub_deptos')
      .doc(depto_id)
      .collection('pages')
      .doc(page_id)
      .update(Object.assign({}, entity));
  }



*/

  // EXAMES

  loadExams (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_exams', ref => ref
      .orderBy('short', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertExam (entity: any) {
    return this.db.collection('pub_exams').add(Object.assign({}, entity));
  }

  updateExam (entity: any) {
    return this.db.collection('pub_exams').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteExam (entity_id: any) {
    return this.db.collection('pub_exams').doc(entity_id).delete();
  }

  /*
    loadExamsPages (id: string): Observable<any[]> {
      return this.db.collection<any>('pub_exams/' + id + "/pages/", ref =>
        ref.orderBy('name', 'asc')
      ).snapshotChanges().pipe(
        map(snapshotActions => snapshotActions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            name: docData.name
          };
        }))
      );
    }
  
    getExamsPage (exam_id: string, page_id: string): Observable<any | undefined> {
      return this.db.collection('pub_exams')
        .doc<any>(exam_id)
        .collection('pages')
        .doc<any>(page_id)
        .valueChanges({idField: 'page_id'})
        .pipe(
          map(doc => {
            if (doc) {
              return {
                exam_id: exam_id,
                page_id: page_id,
                ...doc
              };
            }
            return undefined;
          })
        );
    }
  
    insertExamPage (exam_id: string, entity: any) {
      return this.db.collection('pub_exams')
        .doc(exam_id)
        .collection('pages')
        .add(Object.assign({}, entity));
    }
  
    updateExamPage (exam_id: string, page_id: string, entity: any) {
      return this.db.collection('pub_exams')
        .doc(exam_id)
        .collection('pages')
        .doc(page_id)
        .update(Object.assign({}, entity));
    }
  
  
    deleteExamPage (exam_id: string, page_id: string) {
      return this.db.collection('pub_exams')
        .doc(exam_id)
        .collection('pages')
        .doc(page_id)
        .delete();
    }
  */

  // REGIONALS

  loadRegionals (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_regionals', ref => ref
      .orderBy('short', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertRegional (entity: any) {
    return this.db.collection('pub_regionals').add(Object.assign({}, entity));
  }

  updateRegional (entity: any) {
    return this.db.collection('pub_regionals').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteRegional (entity_id: any) {
    return this.db.collection('pub_regionals').doc(entity_id).delete();
  }
  /*
    loadRegionalsPages (id: string): Observable<any[]> {
      return this.db.collection<any>('pub_regionals/' + id + "/pages/", ref =>
        ref.orderBy('name', 'asc')
      ).snapshotChanges().pipe(
        map(snapshotActions => snapshotActions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            name: docData.name
          };
        }))
      );
    }
  
    getRegionalPage (regional_id: string, page_id: string): Observable<any | undefined> {
      return this.db.collection('pub_regionals')
        .doc<any>(regional_id)
        .collection('pages')
        .doc<any>(page_id)
        .valueChanges({idField: 'page_id'})
        .pipe(
          map(doc => {
            if (doc) {
              return {
                regional_id: regional_id,
                page_id: page_id,
                ...doc
              };
            }
            return undefined;
          })
        );
    }
  
    insertRegionalPage (regional_id: string, entity: any) {
      return this.db.collection('pub_regionals')
        .doc(regional_id)
        .collection('pages')
        .add(Object.assign({}, entity));
    }
  
    updateRegionalPage (regional_id: string, page_id: string, entity: any) {
      return this.db.collection('pub_regionals')
        .doc(regional_id)
        .collection('pages')
        .doc(page_id)
        .update(Object.assign({}, entity));
    }
  

    deleteRegionalPage (regional_id: string, page_id: string) {
      return this.db.collection('pub_regionals')
        .doc(regional_id)
        .collection('pages')
        .doc(page_id)
        .delete();
    }
  */

  // CAROUSEL ////////////////////////

  loadCarousel (location: any): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_carousel', ref => ref
      .where('location', "==", location)
      .orderBy('location', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
      // Não tem try/catch aqui, o tratamento de erro deve ser feito com o pipe 'catchError'
      // ou na subscrição no componente.
    );
  }

  insertCarousel (entity: any) {
    return this.db.collection('pub_carousel')
      .add(Object.assign({}, entity));
  }

  updateCarousel (id: string, entity: any) {
    return this.db.collection('pub_carousel')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteCarousel (id: string) {
    return this.db.collection('pub_carousel')
      .doc(id)
      .delete();
  }

  // NEWS ////////////////////////

  loadNews (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_news', ref => ref
      .where('dateIn', '<=', dt)
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            ...docData
          };
        });
        return array;
      })
    );
  }

  insertNews (entity: any) {
    return this.db.collection('pub_news')
      .add(Object.assign({}, entity));
  }

  updateNews (id: string, entity: any) {
    return this.db.collection('pub_news')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteNews (id: string) {
    return this.db.collection('pub_news')
      .doc(id)
      .delete();
  }


  // NEWS ////////////////////////

  loadArtigos (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_artigos', ref => ref
      .where('dateIn', '<=', dt)
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            id: action.payload.doc.id,
            ...docData
          };
        });
        return array;
      })
    );
  }

  insertArtigo (entity: any) {
    return this.db.collection('pub_artigos')
      .add(Object.assign({}, entity));
  }

  updateArtigo (id: string, entity: any) {
    return this.db.collection('pub_artigos')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteArtigo (id: string) {
    return this.db.collection('pub_artigos')
      .doc(id)
      .delete();
  }


  // LINKS  ///////////////////////

  loadLinks (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_links', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }


  insertLinks (entity: any) {
    return this.db.collection('pub_links').add(Object.assign({}, entity));
  }

  updateLinks (entity: any) {
    return this.db.collection('pub_links').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteLink (entity_id: any) {
    return this.db.collection('pub_links').doc(entity_id).delete();
  }

  async generateHtmlPage (prompt: any): Promise<string> {
    console.log("generateHtmlPage")

    const generateHtmlPage = this.ff.httpsCallable('generateHtmlPage');

    try {
      // 1. Usa 'await' para esperar a Promise resolvida pelo lastValueFrom.
      const response: any = await lastValueFrom(generateHtmlPage({'prompt': prompt}));

      const rawHtmlPageOutput = response.result;
      //console.log("rawGeminiOutput: " + rawGeminiOutput);

      return rawHtmlPageOutput;

      // 2. Chama a extração e retorna o HTML extraído.
      // const extractedHtml = this.extractHtml(rawHtmlPageOutput);
      // return extractedHtml; // Retorna o valor final (string)

    } catch (err: any) {
      // Trata e/ou propaga o erro para o componente
      console.error("ERRO! Falha ao gerar conteúdo Gemini: ", err.message);
      // É importante relançar o erro para que o 'catch' no componente o capture.
      throw err;
    }
  }

  async generateGeminiContent (prompt: any): Promise<string> {

    const generateGeminiContent = this.ff.httpsCallable('generateGeminiContent');

    try {
      // 1. Usa 'await' para esperar a Promise resolvida pelo lastValueFrom.
      const response: any = await lastValueFrom(generateGeminiContent({'prompt': prompt}));

      const rawGeminiOutput = response.result;
      // console.log("rawGeminiOutput: " + rawGeminiOutput);

      // 2. Chama a extração e retorna o HTML extraído.
      const extractedHtml = this.extractHtml(rawGeminiOutput);
      return extractedHtml; // Retorna o valor final (string)

    } catch (err: any) {
      // Trata e/ou propaga o erro para o componente
      console.error("ERRO! Falha ao gerar conteúdo Gemini: ", err.message);
      // É importante relançar o erro para que o 'catch' no componente o capture.
      throw err;
    }
  }


  extractHtml (data) {
    //console.log("extractHtml")
    const htmlBlockRegex = /<!DOCTYPE html>[\s\S]*?<\/html>/;
    const match = data.match(htmlBlockRegex);
    if (match && match[ 0 ]) {
      const extractedHtml = match[ 0 ].trim();
      return extractedHtml;
    } else {
      return null;
    }
  }

  extractStyle (data: string) {
    const styleRegex = /(\<style\>[\s\S]*?\<\/style\>)/i;
    const styleMatch = data.match(styleRegex);
    let style = null;
    if (styleMatch && styleMatch[ 1 ]) {
      style = styleMatch[ 1 ].trim();
      return style;
    } else {
      return null;
    }
  }

  extractBody (data: string) {
    const bodyContentRegex = /<body[^>]*>([\s\S]*?)<\/body>/i;
    const bodyMatch = data.match(bodyContentRegex);
    let bodyContent = null;
    if (bodyMatch && bodyMatch[ 1 ]) {
      bodyContent = bodyMatch[ 1 ].trim();
      return bodyContent;
    } else {
      return null;
    }
  }


  // YOUTUBE ////////////////////////

  loadYoutube (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_youtube', ref => ref
      .where('date', '<=', dt)
      .orderBy('date', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertYoutube (entity: any) {
    return this.db.collection('pub_youtube')
      .add(Object.assign({}, entity));
  }

  updateYoutube (id: string, entity: any) {
    return this.db.collection('pub_youtube')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteYoutube (id: string) {
    return this.db.collection('pub_youtube')
      .doc(id)
      .delete();
  }



  // VIMEO ////////////////////////

  loadVimeo (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_vimeo', ref => ref
      // .where('date', '<=', dt)
      .orderBy('date', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertVimeo (entity: any) {
    return this.db.collection('pub_vimeo')
      .add(Object.assign({}, entity));
  }

  updateVimeo (id: string, entity: any) {
    return this.db.collection('pub_vimeo')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteVimeo (id: string) {
    return this.db.collection('pub_vimeo')
      .doc(id)
      .delete();
  }

  // GALLERY ////////////////////////

  loadGallery (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_gallery', ref => ref
      .orderBy('date', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertGallery (entity: any) {
    return this.db.collection('pub_gallery')
      .add(Object.assign({}, entity));
  }

  updateGallery (id: string, entity: any) {
    return this.db.collection('pub_gallery')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteGallery (id: string) {
    // return this.db.collection('pub_gallery')
    //  .doc(id)
    //   .delete();

    return this.db.collection('pub_gallery')
      .doc(id)
      .update(Object.assign({}, {deleted: true}));
  }

  loadGalleryPhotos (id: string): Observable<any[]> {
    return this.db.collection<any>('pub_gallery/' + id + "/photos/", ref =>
      ref.where('deleted', '==', false).orderBy('name', 'asc')
    ).snapshotChanges().pipe(
      map(snapshotActions => snapshotActions.map(action => {
        const docData = action.payload.doc.data();
        return {
          ...docData,
          id: action.payload.doc.id,
        };
      }))
    );
  }


  getGalleryPhoto (gallery_id: string, photo_id: string): Observable<any | undefined> {
    return this.db.collection('pub_gallery')
      .doc<any>(gallery_id)
      .collection('photos')
      .doc<any>(photo_id)
      .valueChanges({idField: 'photo_id'})
      .pipe(
        map(doc => {
          if (doc) {
            return {
              ...doc,
              gallery_id: gallery_id,
              photo_id: photo_id,

            };
          }
          return undefined;
        })
      );
  }

  insertGalleryPhoto (gallery_id: string, entity: any) {
    return this.db.collection('pub_gallery')
      .doc(gallery_id)
      .collection('photos')
      .add(Object.assign({}, entity));
  }

  updateGalleryPhoto (gallery_id: string, photo_id: string, entity: any) {
    return this.db.collection('pub_gallery')
      .doc(gallery_id)
      .collection('photos')
      .doc(photo_id)
      .update(Object.assign({}, entity));
  }

  deleteGalleryPhoto (gallery_id: string, photo_id: string) {

    console.log("gallery_id: " + gallery_id);
    console.log("photo_id: " + photo_id);

    return this.db.collection('pub_gallery')
      .doc(gallery_id)
      .collection('photos')
      .doc(photo_id)
      .delete();
  }

  // EVENTS ////////////////////////

  loadSiteEvents (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_events', ref => ref
      .orderBy('dateStart', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertSiteEvents (entity: any) {
    return this.db.collection('pub_events')
      .add(Object.assign({}, entity));
  }

  updateSiteEvents (id: string, entity: any) {
    return this.db.collection('pub_events')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteSiteEvents (id: string) {
    return this.db.collection('pub_events')
      .doc(id)
      .delete();
  }

  // BULLETIN ////////////////////////

  loadBulletins (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_bulletins', ref => ref
      .orderBy('year', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertBulletin (entity: any) {
    return this.db.collection('pub_bulletins')
      .add(Object.assign({}, entity));
  }

  updateBulletin (id: string, entity: any) {
    return this.db.collection('pub_bulletins')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteBulletin (id: string) {
    return this.db.collection('pub_bulletins')
      .doc(id)
      .delete();
  }

  loadBulletinPDFs (id: string): Observable<any[]> {
    return this.db.collection<any>('pub_bulletins/' + id + "/pdfs/", ref =>
      ref.orderBy('name', 'asc')
    ).snapshotChanges().pipe(
      map(snapshotActions => snapshotActions.map(action => {
        const docData = action.payload.doc.data();
        return {
          ...docData,
          id: action.payload.doc.id,
        };
      }))
    );
  }

  getBulletinPDF (bulletin_id: string, pdf_id: string): Observable<any | undefined> {
    return this.db.collection('pub_bulletins')
      .doc<any>(bulletin_id)
      .collection('pdfs')
      .doc<any>(pdf_id)
      .valueChanges({idField: 'pdf_id'})
      .pipe(
        map(doc => {
          if (doc) {
            return {
              ...doc,
              bulletin_id: bulletin_id,
              pdf_id: pdf_id,

            };
          }
          return undefined;
        })
      );
  }

  insertBulletinPDF (bulletin_id: string, entity: any) {
    return this.db.collection('pub_bulletins')
      .doc(bulletin_id)
      .collection('pdfs')
      .add(Object.assign({}, entity));
  }

  updateBulletinPDF (bulletin_id: string, pdf_id: string, entity: any) {
    return this.db.collection('pub_bulletins')
      .doc(bulletin_id)
      .collection('pdfs')
      .doc(pdf_id)
      .update(Object.assign({}, entity));
  }

  deleteBulletinPDF (bulletin_id: string, pdf_id: string) {

    console.log("gallery_id: " + bulletin_id);
    console.log("photo_id: " + pdf_id);

    return this.db.collection('pub_bulletins')
      .doc(bulletin_id)
      .collection('pdfs')
      .doc(pdf_id)
      .delete();
  }

  // MAGAZINE ////////////////////////

  loadMagazines (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_magazines', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertMagazine (entity: any) {
    return this.db.collection('pub_magazines')
      .add(Object.assign({}, entity));
  }

  updateMagazine (id: string, entity: any) {
    return this.db.collection('pub_magazines')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteMagazine (id: string) {
    return this.db.collection('pub_magazines')
      .doc(id)
      .delete();
  }

  // TAVI - Docs

  loadTaviDocs (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_tavi_docs', ref => ref
      .orderBy('title', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertTaviDoc (entity: any) {
    return this.db.collection('pub_tavi_docs').add(Object.assign({}, entity));
  }

  updateTaviDoc (entity: any) {
    return this.db.collection('pub_tavi_docs').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteTaviDoc (entity_id: any) {
    return this.db.collection('pub_tavi_docs').doc(entity_id).delete();
  }

  // TAVI - Professionals

  loadTaviProfs (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_tavi_profs', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertTaviProf (entity: any) {
    return this.db.collection('pub_tavi_profs').add(Object.assign({}, entity));
  }

  updateTaviProf (entity: any) {
    return this.db.collection('pub_tavi_profs').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteTaviProf (entity_id: any) {
    return this.db.collection('pub_tavi_profs').doc(entity_id).delete();
  }

  // TAVI - Centers

  loadTaviCenters (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_tavi_centers', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertTaviCenter (entity: any) {
    return this.db.collection('pub_tavi_centers').add(Object.assign({}, entity));
  }

  updateTaviCenter (entity: any) {
    return this.db.collection('pub_tavi_centers').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteTaviCenter (entity_id: any) {
    return this.db.collection('pub_tavi_centers').doc(entity_id).delete();
  }

  // RESIDENTS ////////////////////////

  loadResidents (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_residents', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertResident (entity: any) {
    return this.db.collection('pub_residents')
      .add(Object.assign({}, entity));
  }

  updateResident (entity: any) {
    return this.db.collection('pub_residents')
      .doc(entity.id)
      .update(Object.assign({}, entity));
  }

  deleteResident (id: string) {
    return this.db.collection('pub_residents')
      .doc(id)
      .delete();
  }

  // PORTARIAS ////////////////////////

  loadRegulations (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_regulations', ref => ref
      .orderBy('date', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertRegulation (entity: any) {
    return this.db.collection('pub_regulations')
      .add(Object.assign({}, entity));
  }

  updateRegulation (id: any, entity: any) {
    return this.db.collection('pub_regulations')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteRegulation (id: string) {
    return this.db.collection('pub_regulations')
      .doc(id)
      .delete();
  }

  // GUIDELINES  ///////////////////////

  loadGuidelines (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const dt = new Date();
    const query = this.db.collection<any>('pub_guidelines', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }


  insertGuideline (entity: any) {
    return this.db.collection('pub_guidelines').add(Object.assign({}, entity));
  }

  updateGuideline (id: string, entity: any) {
    return this.db.collection('pub_guidelines').doc(id).update(Object.assign({}, entity));
  }

  deleteGuideline (entity_id: any) {
    return this.db.collection('pub_guidelines').doc(entity_id).delete();
  }

  // CONGRESSOS ANTERIORES ////////////////////////

  loadCongressesBefore (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_congresses_before', ref => ref
      .orderBy('year', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id,
          };
        });
        return array;
      })
    );
  }

  insertCongressBefore (entity: any) {
    return this.db.collection('pub_congresses_before')
      .add(Object.assign({}, entity));
  }

  updateCongressBefore (id: any, entity: any) {
    return this.db.collection('pub_congresses_before')
      .doc(id)
      .update(Object.assign({}, entity));
  }

  deleteCongressBefore (id: string) {
    return this.db.collection('pub_congresses_before')
      .doc(id)
      .delete();
  }

  loadCongressBeforePDFs (id: string): Observable<any[]> {
    return this.db.collection<any>('pub_congresses_before/' + id + "/pdfs/", ref =>
      ref.orderBy('name', 'asc')
    ).snapshotChanges().pipe(
      map(snapshotActions => snapshotActions.map(action => {
        const docData = action.payload.doc.data();
        return {
          ...docData,
          id: action.payload.doc.id,
        };
      }))
    );
  }

  getCongressBeforePDF (congress_id: string, pdf_id: string): Observable<any | undefined> {
    return this.db.collection('pub_congresses_before')
      .doc<any>(congress_id)
      .collection('pdfs')
      .doc<any>(pdf_id)
      .valueChanges({idField: 'pdf_id'})
      .pipe(
        map(doc => {
          if (doc) {
            return {
              ...doc,
              congress_id: congress_id,
              pdf_id: pdf_id,
            };
          }
          return undefined;
        })
      );
  }

  insertCongressBeforePDF (congress_id: string, entity: any) {
    return this.db.collection('pub_congresses_before')
      .doc(congress_id)
      .collection('pdfs')
      .add(Object.assign({}, entity));
  }

  updateCongressBeforePDF (congress_id: string, pdf_id: string, entity: any) {
    return this.db.collection('pub_congresses_before')
      .doc(congress_id)
      .collection('pdfs')
      .doc(pdf_id)
      .update(Object.assign({}, entity));
  }

  deleteCongressBeforePDF (congress_id: string, pdf_id: string) {
    return this.db.collection('pub_congresses_before')
      .doc(congress_id)
      .collection('pdfs')
      .doc(pdf_id)
      .delete();
  }


  // Site Event Form - Normas Eventos 
  loadEventSupport (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_event_support', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertEventSupport (entity: any) {
    return this.db.collection('pub_event_support').add(Object.assign({}, entity));
  }

  updateEventSupport (entity: any) {
    return this.db.collection('pub_event_support').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteEventSupport (entity_id: any) {
    return this.db.collection('pub_event_support').doc(entity_id).delete();
  }

  // Site Event Form - Normas Eventos 
  loadBecomeMember (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_become_member', ref => ref
      .orderBy('name', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertBecomeMember (entity: any) {
    return this.db.collection('pub_become_member').add(Object.assign({}, entity));
  }

  updateBecomeMember (entity: any) {
    return this.db.collection('pub_become_member').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteBecomeMember (entity_id: any) {
    return this.db.collection('pub_become_member').doc(entity_id).delete();
  }


  // Congresso Atual 
  loadCongressCurrent (edition: any): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('pub_congress_current', ref => ref
      .orderBy('title', 'asc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data();
          return {
            ...docData,
            id: action.payload.doc.id
          };
        });
        return array;
      })
    );
  }

  insertCongressCurrent (entity: any) {
    return this.db.collection('pub_congress_current').add(Object.assign({}, entity));
  }

  updateCongressCurrent (entity: any) {
    return this.db.collection('pub_congress_current').doc(entity.id).update(Object.assign({}, entity));
  }

  deleteCongressCurrent (entity_id: any) {
    return this.db.collection('pub_congress_current').doc(entity_id).delete();
  }

  loadLocations () {
    const array = []
    array.push("Site");
    array.push("Congresso52");
    array.push("Congresso53");
    array.push("Programa52");
    array.push("Programa53");
    array.push('Convidados52');
    array.push('Convidados53');
    return array;
  }


}

